<script>

  /**
   * Library Imports
   */
  import { onMount, onDestroy } from 'svelte';
  import scrollama from 'scrollama';
  import PanelSnap from 'panelsnap';

  /**
   * Component Imports
   */
  import Back from './assets/Back.svelte';

  /**
   * Prop imports
   */
  export let data;
  export let type;
  export let linkToArticles;

  const COLOR_MAP = {
    global: '#8EC089',
    local: '#2F4666',
    digital: '#DC8014'
  };

  const category = data.categories[type];

  const breakpoint = 768;
  let width = window.innerWidth;

  // Look for resize event
  window.addEventListener('resize', () => {
    width = window.innerWidth;
  });

  // initialize the scrollama
  const scroller = scrollama();

  let snapper;

  // generic window resize listener event
  function handleResize() {
    // tell scrollama to update new element dimensions
    scroller.resize();
  }

  function init() {
    // 1. force a resize on load to ensure proper dimensions are sent to scrollama
    handleResize();

    // 2. setup the scroller passing options
    // 		this will also initialize trigger observations
    // 3. bind scrollama event handlers (this can be chained like below)
    scroller.setup({
      step: '.card',
      offset: 0.5,
      // debug: true,
    }).onStepEnter(({ element, index }) => {
      document.getElementById(`status-${index}`).classList.add('active');
    }).onStepExit(({ element, index }) => {
      document.getElementById(`status-${index}`).classList.remove('active');
    });

    // setup resize event
    window.addEventListener('resize', handleResize);
  }

  onMount(() => {
    // kick things off
    init();

    document.querySelector(`body`).scrollIntoView();

    snapper = new PanelSnap({
      container: document.body,
      panelSelector: 'div.card'
    });
  });

  onDestroy(() => {
    scroller.destroy();
    snapper.destroy();
  });

  const redirect = () => {
    location.hash = 'category';
    linkToArticles();
  }
</script>

<style>
  * {
    color: black;
  }

  h1 {
    font-size: 36px;
    font-weight: bold;
    line-height: 1.3em;
    margin-bottom: 30px;
  }

  h3 {
    font-size: 28px;
    margin-bottom: 30px;
  }

  p {
    font-size: 18px;
    line-height: 1.3em;
  }

  .card {
    height: 100vh;
    position: relative;
  }

  .card-image {
    display: inline-block;
    vertical-align: top;
    width: 33vw;
    height: 100vh;
    background-size: cover;
    background-position: center;
  }

  .card-content {
    display: inline-block;
    vertical-align: top;
    width: 50vw;
    height: 100vh;
    padding: 60px;
  }

  .card-content-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  .card a {
    margin-top: 20px;
    padding: 20px;
    display: inline-block;
  }

  .card a:hover { text-decoration: none; color: unset; }

  .card.global a { background-color: #BEDDBB; color: black; }
  .card.local a { background-color: #2F4666; color: white; }
  .card.digital a { background-color: #EDB548; color: black; }

  .article-page-img {
    position: absolute;
    right: 0;
    bottom: 0;
    height: 150px;
  }

  @media screen and (max-width: 768px) {
    h1 {
      font-size: 24px;
    }

    h3 {
      font-size: 14px;
    }

    p {
      font-size: 14px;
    }

    .card-image, .card-content {
      width: 100vw;
    }

    .card-image {
      height: 30vh;
    }

    .card-content {
      height: 70vh;
      padding: 30px;
    }

    .article-page-img {
      display: none;
    }
  }

  /* ******************************************************
   * STATUS CLASSES
   */
  .status {
    position: fixed;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: right;
    top: 0;
    bottom: 0;
    right: 0;
  }

  .status-line-wrap {
    margin: 10px 0;
    width: 80px;
    position: relative;
  }

  .status-line {
    width: 30px;
    border-top: 2px solid;
    transition: all 0.5s;
    position: absolute;
    right: 0;
  }

  .status-line.active {
    width: 80px;
  }

  .status-line.global { border-color: #BEDDBB; }
  .status-line.local { border-color: #2F4666; }
  .status-line.digital { border-color: #EDB548; }

  @media screen and (max-width: 768px) {
    .status {
      display: none;
    }
  }

  /* ******************************************************
   * BACK CLASSES
   */
  .back {
    position: fixed;
    top: 20px;
    left: 20px;
  }

  .back-button {
    background: none;
    border: none;
    padding: 0;
  }
</style>

<div class="articles">
  {#each category.articles as article}
    <div class="card {type}">
      <div class="card-image" style="background-image: url('{(width < breakpoint && article.article_img_mobile) ? article.article_img_mobile : article.article_img}');"></div>
      <div class="card-content">
        <div class="card-content-center">
          <div>
            <h3>{article.article_cata}</h3>
            <h1>{article.article_title}</h1>
            <p>{article.article_description}</p>
            <a target="_blank" rel="noopener noreferrer" href="{article.article_link} ">{article.article_btn}</a>
          </div>
        </div>
      </div>
      {#if article.article_page_img}
        <img class="article-page-img" src="{article.article_page_img}" alt="Page Description">
      {/if}
    </div>
  {/each}
</div>

<div class="status">
  {#each category.articles as article, i}
    <div class="status-line-wrap">
      <div class="status-line {type}" id="status-{i}"></div>
    </div>
  {/each}
</div>

<div class="back">
  <button class="back-button" on:click={redirect}><Back color="{COLOR_MAP[type]}" /></button>
</div>
